<template>
  <div id="imagePage">
    <!-- 图片显示 -->
    <div class="lawPhase">
      <div
        class="img"
        v-for="(item, index) in imgList"
        :key="index"
        @click="bigImage(item.picture_url)"
      >
        <img :src="item.picture_url" alt />
      </div>
    </div>
    <!-- 图片预览 -->
    <div :class="imageFlag ? 'show' : 'none'" @click="cloesed">
      <img :src="bigImageUrl" alt="" />
    </div>

    <!-- 分页 -->
    <div class="splitPage flex-center">
      <el-pagination
        background
        @current-change="handleCurrentChange"
        :page-size="page.per_page"
        layout=" prev, pager, next"
        :pager-count="3"
        :total="page.total"
        :prev-text="$t('preText')"
        :next-text="$t('nextText')"
      ></el-pagination>
    </div>
    <!-- <empty></empty> -->
  </div>
</template>

<script>
import { getCateList, getPicture } from "../../api/apis";
import empty from "../../components/empty.vue";
export default {
  name: "",
  props: ["cateId"],
  components: { empty },
  data() {
    return {
      page: {
        total: 0,
        per_page: 20,
        current_page: 1,
        last_page: 1,
      },
      imgList: [
        // {
        //     url: require("../../static/img/plowCloudMentor/pic1.png")
        // },
        // {
        //     url: require("../../static/img/plowCloudMentor/pic2.png")
        // },
        // {
        //     url: require("../../static/img/plowCloudMentor/pic3.png")
        // },
        // {
        //     url: require("../../static/img/plowCloudMentor/pic4.png")
        // }
      ],
      imageFlag: false,
      bigImageUrl: "",
    };
  },
  methods: {
    //关闭预览
    cloesed() {
      this.bigImageUrl = "";
      this.imageFlag = false;
    },
    //图片预览
    bigImage(e) {
      this.imageFlag = true;
      this.bigImageUrl = e;
    },
    // 请求页面
    getPicList() {
      let page = {
        page: this.page.current_page,
        limit: this.page.per_page,
      };
      getPicture(this.cateId, page).then((res) => {
        this.imgList = res.data;
        this.page.total = res.total;
        this.page.per_page = res.per_page;
        this.page.current_page = res.current_page;
        this.page.last_page = res.last_page;
      });
    },
    //页面改变
    handleCurrentChange(e) {
      this.page.current_page = e;
      this.getPicList();
    },
  },
  mounted() {
    getCateList().then((res) => {
      this.cateId = res[0][1].id;
      this.getPicList();
    });
  },
};
</script>

<style scoped>
#imagePage .show {
  position: fixed;
  top: 0;
  left: 0;
  bottom: 0;
  right: 0;
  display: block;
  background: rgba(0, 0, 0, 0.8);
}
#imagePage .none {
  display: none;
}
#imagePage .show img {
  width: 100%;
  height: 100%;
}
.lawPhase {
  /* display: grid;
    grid-template-columns: repeat(2, 49%);
    grid-gap: 0.5rem; */
  display: flex;
  justify-content: space-between;
  box-sizing: border-box;
  padding: 0.8rem 0.64rem;
  flex-wrap: wrap;
}
.lawPhase .img {
  width: 9.07rem;
  margin-bottom: 0.64rem;
}

img {
  /* height: 9.07rem; */
  width: 100%;
  height: 100%;
  object-fit: contain;
}
/* .splitPage {
    margin-top: 3rem;
    margin-bottom: 3rem;
} */
</style>